import { createContext } from "react";

//form error

//form info
export interface IRoleManagementFormContext {
  mode: "Edit" | "Add" | "Info";
}
export const RoleManagementFormContext = createContext<IRoleManagementFormContext | null>(null);
